import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.303 15.794q.196-.104.345-.267a1.18 1.18 0 0 0 .299-.927l-.7-6.284a1.17 1.17 0 0 0-.785-.99v-.974a1.41 1.41 0 0 0-.817-1.265V2.573a.786.786 0 0 0-.785-.786h-2.357a.785.785 0 0 0-.786.786v2.514a1.41 1.41 0 0 0-.785 1.265v1.005a1.16 1.16 0 0 0-.739.723H8.814a1.16 1.16 0 0 0-.738-.723V6.352a1.41 1.41 0 0 0-.786-1.265V2.573a.786.786 0 0 0-.785-.786H4.148a.786.786 0 0 0-.785.786v2.514a1.41 1.41 0 0 0-.786 1.265v1.005a1.17 1.17 0 0 0-.786.99l-.699 6.285a1.18 1.18 0 0 0 .299.927q.15.163.345.267l-.73 5.507a.786.786 0 0 0 .785.88h7.07a.79.79 0 0 0 .75-.554.8.8 0 0 0 .028-.326l-.691-5.5q.196-.103.346-.267c.102-.11.18-.242.227-.385h4.965q.073.218.228.386.15.163.346.267l-.7 5.499a.784.784 0 0 0 .786.88h7.07a.79.79 0 0 0 .75-.554.8.8 0 0 0 .028-.326zM9.474 13.571l-.432-3.928h5.924l-.432 3.928zm-1.799 4.714H2.962l.29-2.357H7.37zM3.284 8.858h4.085l.613 5.499h-5.31zM4.148 6.5h2.357v.785H4.148zm12.49 2.357h4.086l.613 5.499h-5.31zm.865-2.357h2.357v.785h-2.357zm-.88 9.427h4.117l.29 2.357h-4.713zm1.666-12.57h.785V4.93h-.785zm-13.355 0h.785V4.93h-.785zM2.679 20.642l.102-.785h5.09l.103.785zm13.355 0 .102-.785h5.09l.103.785z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.79 11.214h-1.572a.786.786 0 0 0 0 1.572h1.572a.786.786 0 0 0 0-1.572"
    }, null, -1)
  ]))]))
}
export default { render: render }